import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "/data/landun/workspace/b-b500fbb73f7c4dbc898306ee34f35371/codebase/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "/data/landun/workspace/b-b500fbb73f7c4dbc898306ee34f35371/codebase/node_modules/core-js/modules/es.array.iterator.js";
import "/data/landun/workspace/b-b500fbb73f7c4dbc898306ee34f35371/codebase/node_modules/core-js/modules/es.promise.js";
import "/data/landun/workspace/b-b500fbb73f7c4dbc898306ee34f35371/codebase/node_modules/core-js/modules/es.object.assign.js";
import "/data/landun/workspace/b-b500fbb73f7c4dbc898306ee34f35371/codebase/node_modules/core-js/modules/es.promise.finally.js";
import Vue from 'vue';
import App from '@/App.vue';
import store from '@/store';
import { setPageTitle, setShare } from '@vip-activity/business/pageSetting';
import { loginService } from '@vip-activity/business';
import { setSize } from '@tencent/vft-style/src/adaptation';
import eventBus from './util/eventBus';
import envCheck from './util/envCheck';
import '@/plugins';
import '@/mixin/index.js';
import '@/mixin/level';
import '@/mixin/download';
import reportData from './config/reportData';
Vue.prototype.reportData = reportData;
Vue.config.productionTip = false;
Vue.prototype.setting = window.setting;
Vue.prototype.eventBus = eventBus;
var _window$setting$环境兼容 = window.setting.环境兼容,
    pad链接 = _window$setting$环境兼容.pad链接,
    pc链接 = _window$setting$环境兼容.pc链接,
    pad图 = _window$setting$环境兼容.pad图;

var getInitInfo = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (loginService.isLogin) {
              // 登录情况下，拉取用户相关的信息
              try {
                console.log('登录成功');
              } catch (e) {
                Vue.prototype.toast('获取参赛信息失败');
              }
            }

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getInitInfo() {
    return _ref.apply(this, arguments);
  };
}();

envCheck({
  padUrl: pad链接,
  pcUrl: pc链接,
  padPic: pad图
}, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
  return regeneratorRuntime.wrap(function _callee2$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          setSize();
          _context2.prev = 1;
          _context2.next = 4;
          return loginService.init();

        case 4:
          _context2.next = 9;
          break;

        case 6:
          _context2.prev = 6;
          _context2.t0 = _context2["catch"](1);
          console.log(_context2.t0);

        case 9:
          new Vue({
            store: store,
            render: function render(h) {
              return h(App);
            }
          }).$mount('#app');
          getInitInfo();
          setPageTitle();
          setShare();

        case 13:
        case "end":
          return _context2.stop();
      }
    }
  }, _callee2, null, [[1, 6]]);
})));